module.exports = window.wx;